import React from "react";
import { MessageCircle, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function EvaluateYourAiReadiness() {
  return <section data-section-id="223385" id="evaluate-your-ai-readiness" className="dark bg-background text-foreground py-16 px-4 sm:py-24">
      <div className="mx-auto max-w-5xl">
        <div className="relative overflow-hidden rounded-xl bg-chart-3 px-6 py-16 shadow-2xl sm:px-16 sm:py-24 text-center border border-border">
          {}
          <div className="absolute inset-0 opacity-5" style={{
          backgroundImage: "radial-gradient(circle at 2px 2px, white 1px, transparent 0)",
          backgroundSize: "24px 24px"
        }} aria-hidden="true" />

          <div className="relative z-10 mx-auto max-w-3xl">
            <h2 className="font-default text-3xl font-bold tracking-tight text-white sm:text-5xl md:text-6xl">
              Evaluate Your AI Readiness
            </h2>
            <p className="mt-6 text-lg text-white/80 max-w-2xl mx-auto font-default">
              Discover how your current workflows can be transformed into high-value AI operating models for measurable business outcomes.
            </p>

            <div className="mt-10 flex flex-col items-center justify-center gap-6 sm:flex-row">
              <Button size="lg" className="h-14 rounded-lg px-8 text-lg shadow-md transition-all hover:scale-105 bg-chart-1 text-white hover:bg-chart-2" asChild>
                <Link to="/AIReadinessPage">
                  Start Assessment
                  <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>

              <Link to="/ConnectPage" className="group inline-flex items-center gap-2 text-lg font-semibold text-chart-1 transition-colors hover:text-white">
                <MessageCircle className="size-6 transition-transform group-hover:scale-110" />
                <span>Speak with a Consultant</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}